import React from 'react';
import { useAppSelector } from '../../store/hook';
import { getTemplateLayout } from '../../common/utils/fallbackCondition';
import PaperContainerLayout1 from './layout_01/PaperContainerLayout';
import PaperContainerLayout2 from './layout_02/PaperContainerLayout';
export interface PaperContainerProps {
  variant: 'small' | 'large' | 'medium'; // Small - 480px, Large: 960px, medium: 720px
  children: React.ReactNode;
  className?: string;
}

const PaperContainer = ({ variant, children, className }: PaperContainerProps): React.JSX.Element => {
  const JourneyLayoutMap: { [key: string]: React.FC<PaperContainerProps> } = {
    TEMPLATE_LAYOUT_01: PaperContainerLayout1,
    TEMPLATE_LAYOUT_02: PaperContainerLayout2,
    TEMPLATE_LAYOUT_04: PaperContainerLayout2,
  };

  const { layoutCode } = useAppSelector((state) => state.template);

  const layout = getTemplateLayout(layoutCode);
  const PageContainerLayout = JourneyLayoutMap[layout];

  return (
    <PageContainerLayout variant={variant} className={className}>
      {children}
    </PageContainerLayout>
  );
};

export default PaperContainer;
